export enum CREATIVE_TYPE {
  WRITER = 'writer',
  DESIGNER = 'designer',
}
